import React, { Fragment, useState } from 'react';
import { Button, Card, Col, DatePicker, Form, Icon, Modal, Result, Row, Tooltip } from 'antd';
import * as CommonService from '../../../../services/CommonService';
import { SUPPLIER } from '../../../../services/endpoint';
import { currencyVND } from '../../../../utils';
import TextArea from 'antd/es/input/TextArea';
import SelectInfinitePro from '../../../../components/common/select-infinite-pro';
import SupplierCreate from '../../../supplier/create';

export default (props) => {

	const { getFieldDecorator } = props.form;
	const { supplier, setSupplier } = props;
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [value, setValue] = useState(null);

	const handleSelect = async (value) => {
		setValue(value);
		if (value) {
			window.setLoading(true);
			const response = await CommonService.findById(SUPPLIER, value.value);
			setSupplier(response.data || null);
			window.setLoading(false);
		} else {
			setSupplier(null);
		}
		return false;
	};

	const InfoRow = ({ label, value }) => (
		<Row style={{ marginBottom: 8 }}>
			<Col span={10}>{label}</Col>
			<Col span={14}>: {value || '---'}</Col>
		</Row>
	);

	const renderAddress = () => {
		return [supplier.ward, supplier.district, supplier.province].filter(el => el).join(' - ');
	};

	const indicator = () => {
		return <Tooltip title={'Thêm mới sản phẩm'}>
			<Button
				type={'link'}
				style={{ padding: 0 }}
				onClick={(e) => {
					setIsModalOpen(true);
				}}
			>
				➕
			</Button>
		</Tooltip>;
	};

	return (<Fragment>
		<Row gutter={12}>
			<Col lg={16}>
				<Card title={<Fragment><Icon type="user" /> Thông tin nhà cung cấp</Fragment>}>
					<Row gutter={12}>
						<Col>
							<SelectInfinitePro endpoint={SUPPLIER}
																 handleSelect={handleSelect}
																 placeholder={'Tìm theo tên, SĐT, mã nhà cung cấp...'}
																 indicator={indicator}
																 value={value}
							/>
							{supplier ? <Row className={'mt-20'}>
									<h1>Chi tiết nhà cung cấp: <Button type={'link'} size={'large'}><b>{supplier.name}</b></Button></h1>
									<Col span={12}>
										<InfoRow label="Mã nhà cung cấp" value={supplier.code} />
										<InfoRow label="Số điện thoại" value={supplier.phoneNumber} />
										<InfoRow label="Email" value={supplier.email} />
										<InfoRow label="Địa chỉ" value={renderAddress()} />
									</Col>
									<Col span={12}>
										<InfoRow label="Nợ hiện tại"
														 value={<span style={{ color: 'red' }}>{currencyVND(supplier.totalDebt)}</span>} />
										{/*<InfoRow label="Tổng đơn nhập (?)"*/}
										{/*				 value={<b style={{ color: 'blue' }}>{currencyVND(163100020)}</b>} />*/}
										{/*<InfoRow label="Trả hàng" value={<b style={{ color: 'red' }}>{currencyVND(163100020)}</b>} />*/}
									</Col>
								</Row> :
								<Result className={'result-ima'}
												style={{ height: '130px', padding: 0, marginTop: '64px' }}
												icon={<Icon type="user" />}
												subTitle="Chưa có thông tin nhà cung cấp"
								/>}
						</Col>
					</Row>
				</Card>
			</Col>
			<Col lg={8}>
				<Card title={'Thông tin đơn nhập hàng'}>
					<Form.Item
						label={'Ngày hẹn giao'}>
						{getFieldDecorator('deliveryDate',
							{}
						)(
							<DatePicker
								style={{ width: '100%' }}
								showTime={{ format: 'HH:mm' }}
								format="YYYY-MM-DD HH:mm"
								allowClear
								placeholder={'Chọn ngày hẹn giao'} />
						)}

					</Form.Item>
					<Form.Item
						style={{ marginBottom: 4 }}
						label={'Ghi chú'}>
						{getFieldDecorator('note')(
							<TextArea
								style={{ width: '100%' }}
								allowClear
								rows={4}
								placeholder={'Nhập thông tin ghi chú'} />
						)}
					</Form.Item>
				</Card>
			</Col>
		</Row>
		<Modal visible={isModalOpen} title={'Thêm mới nhà cung cấp'} footer={false} centered width={'large'}
					 style={{overflow: 'hidden' }} closable={false}>
			<SupplierCreate onExit={(form) => {
				setIsModalOpen(false);
				form.resetFields();
			}} callback={async (item, form) => {
				setIsModalOpen(false);
				const selected = {
					label: `${item.name} - ${item?.phoneNumber || 'SĐT chưa xác định'}`,
					value: item.id,
					data: item
				}
				setValue(selected)
				await handleSelect(selected);
				form.resetFields();
			}} />

			{/*<ProductCreate callback={async (product, form) => {*/}
			{/*	form.resetFields();*/}
			{/*	setIsModalOpen(false);*/}
			{/*	await getPurchaseDetailById(product?.data?.id);*/}
			{/*}} onExit={(form) => {*/}
			{/*	setIsModalOpen(false);*/}
			{/*	form.resetFields();*/}
			{/*}} />*/}
		</Modal>

	</Fragment>);
};
